import { observer } from 'mobx-react-lite';
import { folderPermissionsDialogTitle } from './FolderPermissionsDialog.locstring.json';
import { cancelButton } from 'owa-locstrings/lib/strings/cancelbutton.locstring.json';
import { okButton } from 'owa-locstrings/lib/strings/okbutton.locstring.json';
import loc, { format } from 'owa-localize';
import FolderPermissionForm from './FolderPermissionForm';
import FolderPermissionsList from './FolderPermissionsList';
import FolderPermissionsLoader from './FolderPermissionsLoader';
import {
    showHideFolderPermissionDialog,
    folderPermissionsDialogOkClick,
} from '../actions/internalActions';
import folderPermissionsStore from '../store/store';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Dialog, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { getFolderTable, lazyArePermissionArraysEqual } from 'owa-folders';

import * as React from 'react';

const styles = require('./FolderPermissionsDialog.scss');

/**
 * This component shows Folder Permissions Dialog in UI.
 */
export default observer(function FolderPermissionsDialog() {
    if (!folderPermissionsStore.showFolderPermissionsDialog) {
        return null;
    }

    // This constant is made to make the title of the dialog more readable
    const folderDisplayName = getFolderTable().get(folderPermissionsStore.folderId).DisplayName;
    return (
        <Dialog
            hidden={false}
            dialogContentProps={{
                title: format(loc(folderPermissionsDialogTitle), folderDisplayName),
                showCloseButton: false,
            }}
            onDismiss={closeFolderPermissionsDialog}
            modalProps={{
                isBlocking: true,
                containerClassName: styles.folderPermissionsContainer,
            }}>
            <div className={styles.folderPermissionsBody}>
                {folderPermissionsStore.showLoader && <FolderPermissionsLoader />}
                <FolderPermissionsList />
                <FolderPermissionForm />
            </div>
            <DialogFooter>
                <PrimaryButton
                    disabled={arePermissionsClean()}
                    onClick={folderPermissionsDialogOkClick}
                    text={loc(okButton)}
                />
                <DefaultButton onClick={closeFolderPermissionsDialog} text={loc(cancelButton)} />
            </DialogFooter>
        </Dialog>
    );
});

// This method checks if permissions of view store and folderStore are different or not.
function arePermissionsClean(): boolean {
    const arePermissionArraysEqual = lazyArePermissionArraysEqual.tryImportForRender();
    const serverFetchedFolderData = getFolderTable().get(folderPermissionsStore.folderId);
    // Calculate if equality should be checked.
    const shouldEqualityBeChecked =
            arePermissionArraysEqual /* Is this util defined */ &&
            !folderPermissionsStore.showLoader /* Are we currently are showing loader */ &&
            serverFetchedFolderData.PermissionSet &&
            serverFetchedFolderData.PermissionSet
                .Permissions /* Do we have permissions defined in folderStore */;
    // If equality should not be checked then return true.
    if (!shouldEqualityBeChecked) {
        return true;
    }
    // This constant will be true if view store's permissions are deep equal to folder store's permissions.
    const arePermissionsEqual = arePermissionArraysEqual(
        serverFetchedFolderData.PermissionSet.Permissions,
        folderPermissionsStore.permissions
    );
    return arePermissionsEqual;
}

// Click handler for cancel button of dialog.
function closeFolderPermissionsDialog() {
    showHideFolderPermissionDialog(null, false /* shouldShow */);
}
